<template>
  <div class="legend">
    {{ value }}
    <span>
      <div class="circle" :style="`background: ${color};`"></div>
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ChartLegend',
  props: {
    value: {
      type: String | Number,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;

  font-weight: 700;
  color: #202224;

  span {
    display: flex;
    align-items: center;
    gap: 0.28375rem;

    font-size: 0.5rem;
    font-weight: 600;
    color: #282D32;

    .circle {
      width: 0.425625rem;
      height: 0.425625rem;
    }
  }
}
</style>
